import { router } from "../../../router/index";

const state = {
  m_userInfo: {
    id: "",
    password: "",
    userName: "",
    deptName: "",
    mobile: "",
    email: "",
    address: "",
    accessToken: null,
    refreshToken: null
  },
  loggeduserInfo: {
    userName: "",
    deptName: ""
  },
  modalInfo: {
    obj: null,
    name: "",
    type: "",
    component: null
  },
  dates: []
};
const actions = {
  //REST-API Call & CallBack Common
  async ASYNC_COWORK_REST_ACTION({ state, commit, dispatch }, data) {
    let object = data.data;
    let url = object.url;
    let sendType = object.sendType;
    let obj = object.obj;
    let req = object.req;

    if (sendType == "post") {
      return await obj.$axios
        .post(url, req)
        .then(response => response.data)
        .catch(function(err) {
          console.log(err);
        });
    } else {
      return await obj.$axios
        .get(url, req)
        .then(response => response.data)
        .catch(function(err) {
          console.log(err);
        });
    }
  },
  SYNC_COWORK_REST_ACTION({ state, commit, dispatch }, data) {
    let object = data.data;
    let url = object.url;
    let sendType = object.sendType;
    let obj = object.obj;
    let req = object.req;

    if (sendType == "post") {
      return obj.$axios
        .post(url, req)
        .then(response => response.data)
        .catch(function(err) {
          console.log(err);
        });
    } else {
      return obj.$axios
        .get(url, req)
        .then(response => response.data)
        .catch(function(err) {
          console.log(err);
        });
    }
  },

  SYNC_COWORK_REST_FILE_ACTION({ state, commit, dispatch }, data) {
    let object = data.data;
    let url = object.url;
    let obj = object.obj;
    let frm = object.frm;
    let header = object.header;
    let sendType = object.sendType;

    if (sendType == "post") {
      return obj.$axios
        .post(url, frm, header)
        .then(response => response.data)
        .catch(function(err) {
          console.log(err);
        });
    } else {
      return obj.$axios
        .get(url, frm, header)
        .then(response => response.data)
        .catch(function(err) {
          console.log(err);
        });
    }
  },
  /* 화면 redirect 필요 시 window.location 값 확인 및 가공 하여 이용 */
  redirect() {
    const { search } = window.location;
    const tokens = search.replace(/^\?/, "").split("&");
    const { returnPath } = tokens.reduce((qs, tkn) => {
      const pair = tkn.split("=");
      qs[pair[0]] = decodeURIComponent(pair[1]);
      return qs;
    }, {});
    if (returnPath == undefined) {
      router.push("/");
    } else {
      router.push(returnPath);
    }
  },
  /* 로그아웃 처리 */
  logout({ state, commit }) {
    localStorage.setItem("accessToken", null);
    localStorage.setItem("refreshToken", null);
    localStorage.setItem("Authorization", null);
    //router.push("/login");
    commit("logout");
  },
  /* 회원 가입 처리 시 사용 예정*/
  join({ dispatch, commit }, userInfo) {
    //commit("setUserInfo", joinInfo);
    console.log(dispatch);
    /* axios 를 사용하여 REST-API 호출 및 회원가입 진행 */
    /* userInfo.param.$axios.post("/main/join", userInfo).then(res => {
      console.log(unescape(res.data));
    }); */
  },
  /*  */
  setUserId({ state, commit }, setId) {
    commit("setUserId", setId);
  },
  /* DatePicker 호출 및 초기화 */
  initDatePicker({ state, commit }) {
    let ids = [];
    $('input[type="calendar"]').each(function(i, obj) {
      ids.push(obj.id);

      $(this).datepicker({
        dateFormat: "yy-mm-dd",
        autoclose: true,
        showOn: "button",
        buttonImageOnly: true,
        buttonImage: "../../../../static/css/images/ico_cal.jpg",
        onSelect: function(date, inst) {
          let id = inst.id;
          let arr = [];

          let from = $("#from").val();
          let to = $("#to").val();

          arr.push({ date: { from: from, to: to } });
          commit("setDatesInfo", arr);
        }
      });
    });
  }
};
const mutations = {
  /* login state update */
  login(state, payload) {
    state.m_userInfo.id = payload.id;
    state.m_userInfo.password = payload.password;
    state.m_userInfo.userName = payload.userName;
    state.m_userInfo.deptName = payload.deptName;
    state.m_userInfo.mobile = payload.mobile;
    state.m_userInfo.email = payload.email;
    state.m_userInfo.address = payload.address;
    state.m_userInfo.accessToken = payload.accessToken;
    state.m_userInfo.refreshToken = payload.refreshToken;
    //console.log(state.m_userInfo);
  },
  setToken(state, payload) {
    state.m_userInfo.accessToken = payload.accessToken;
    state.m_userInfo.refreshToken = payload.refreshToken;
  },
  /* logout state update */
  logout(state, payload) {
    state.m_userInfo.accessToken = null;
    state.m_userInfo.refreshToken = null;
  },
  setModalParams(state, modal) {
    state.modalInfo.name = modal.name;
    state.modalInfo.type = modal.type;
    state.modalInfo.value = modal.value;
    state.modalInfo.component = modal.component;
    state.modalInfo.mWidth = modal.width;
    state.modalInfo.mHeight = modal.height;
  },
  setUserId(state, setId) {
    state.m_userInfo.id = setId;
    //console.log(state.m_userInfo.id);
  },
  setUserInfo(state, payload) {
    state.loggeduserInfo.userName = payload.userName;
    state.loggeduserInfo.deptName = payload.deptName;
  },
  setDatesInfo(state, payload) {
    state.dates = payload;
  }
};
const getters = {};

export default { state, actions, mutations, getters, namespaced: true };



// WEBPACK FOOTER //
// ./src/js/store/modules/common.js